import {action, makeAutoObservable, observable} from "mobx";
import {ViewController} from "data/types/structure";
import {inject, injectable} from "inversify";
import {ContestStatus} from "data/enums";
import {INTERVAL} from "data/constants";
import {Bindings} from "data/constants/bindings";
import type {IContestPlayersStore} from "data/stores/contest_players/contest_players.store";

interface IProps {
	status: ContestStatus;
	contestId: number;
}
export interface ILivePlayersController extends ViewController<IProps> {
	get isLive(): boolean;
}

@injectable()
export class LivePlayersController implements ILivePlayersController {
	@observable _status: ContestStatus = ContestStatus.SCHEDULED;
	@observable _contestId: number = 0;
	@observable protected _interval?: ReturnType<typeof setInterval>;
	@observable protected _isSubscribed: boolean = false;

	get isLive() {
		return this._status === ContestStatus.LIVE;
	}
	constructor(
		@inject(Bindings.ContestPlayersStore) private _contestPlayersStore: IContestPlayersStore
	) {
		makeAutoObservable(this);
	}

	@action
	public subscribe() {
		if (this._isSubscribed) {
			return;
		}

		this._isSubscribed = true;

		// void this._contestPlayersStore.fetchPlayers(contestId);

		this._interval = setInterval(() => {
			void this._contestPlayersStore.fetchPlayers(this._contestId);
		}, INTERVAL);
	}

	/**
	 * Stop checking changes
	 * called on dispose
	 * or you can call it when you want to stop listen checksums, for example on the end of the game match/round/etc.
	 */
	@action
	public unSubscribe() {
		this._isSubscribed = false;

		if (this._interval) {
			clearInterval(this._interval);
		}
	}

	dispose() {
		this.unSubscribe();
	}

	init({status, contestId}: IProps) {
		this._status = status;
		this._contestId = contestId;
		this.subscribe();
	}
}
